import React from "react";
import { graphql } from "gatsby";
// import ArticlesComponent from "../components/articles";
import Layout from "../components/layout";
import YunJia from "../components/yunJia"
import LianXi from "../components/lianXi"
import { Link } from "gatsby";
import "../assets/css/main.css";

export const query = graphql`
  query Category($slug: String!) {
    articles: allStrapiArticle(
      sort: {order: DESC, fields: publishedAt},
      filter: { status: { eq: "published" }, category: { slug: { eq: $slug }} }
    ) {
      edges {
        node {
          slug
          title
          publishedAt
          strapiId
          category {
            name
          }
          image {
            childImageSharp {
              fixed(width: 660) {
                src
              }
            }
          }
          author {
            name
            picture {
              childImageSharp {
                fixed(width: 30, height: 30) {
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
    category: strapiCategory(slug: { eq: $slug }) {
      name
    }
  }
`;

const Category = ({ data }) => {
  const articles = data.articles.edges;
  const category = data.category.name;
  // console.log(category);
  // const news = data.articles.edges;
  // const seo = {
  //   metaTitle: category,
  //   metaDescription: `All ${category} articles`,
  // };

  return (
<Layout>
    <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
    <tbody><tr>
      <td width="265" valign="top">
      <table width="263" border="0" cellSpacing="0" cellPadding="0" align="center">
        <tbody><tr>
          <td>&nbsp;</td>
        </tr>
              <tr>
          <td width="263" height="38" background="/images/left_bj1.gif" style={{ paddingLeft: '25px' }}>&nbsp;<span className="STYLE3">新闻中心</span></td>
    </tr>
        <tr>
          <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td width="1" bgcolor="#e5e5e9"></td>
              <td width="261">
            <table width="95%" border="0" cellPadding="0" cellSpacing="0" align="center">
    
    <tbody>
    <tr><td height="25">&nbsp;<img src="/images/1.gif" width="9" height="10" />&nbsp;<a href="/category/news">行业新闻</a></td></tr>
    <tr><td height="25">&nbsp;<img src="/images/1.gif" width="9" height="10" />&nbsp;<a href="/price">最新运价</a></td></tr>
    </tbody>
    </table>
    </td>
    <td width="1"></td>
    </tr>
    </tbody></table></td>
        </tr>
        <tr>
          <td width="263" height="1" bgcolor="#e5e5e9"></td>
        </tr>
              <tr>
          <td>&nbsp;</td>
        </tr>
      </tbody>
      </table>
      {/* 运价 */}
      <YunJia />
       {/* end运价 */}
      <table style={{marginTop: '10px'}} cellSpacing="0" cellPadding="0" width="214" border="0" align="center" background="/images/6.gif" height="200">
                <tbody>
                <tr>
                  <td height="20"></td>
                </tr>
                <tr>
                  <td>
                    <table cellSpacing="0" cellPadding="8" width="210" align="center" border="0">
                      <tbody>
                      <tr><td align="left"><LianXi /></td></tr> 
                      </tbody>
                          </table>
                          </td>
                          </tr>
                          </tbody>
                          </table>
    </td>
      {/* 右栏 */}
      <td valign="top">
      <table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
      <tbody><tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td width="669" height="37" background="/images/index_bj1.gif" style={{paddingLeft:'25px'}}>&nbsp;<span className="STYLE3">{category}</span></td>
      </tr>
      <tr>
      <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
  <tbody><tr>
    <td width="1" bgcolor="#e5e5e9"></td>
    <td width="667"></td>
    <td width="1" bgcolor="#e5e5e9"></td>
  </tr>
</tbody></table>
{articles.map(post => {
          return (
<table width="100%" border="0" cellSpacing="0" cellPadding="0"  key={post.node.strapiId}>
<tbody><tr>
<td width="85%" height="35" align="left"><span className="TOP3"><img src="/images/jt.gif" width="3" height="5" />&nbsp;&nbsp;<Link to={`/article/${post.node.slug}`} className="uk-link-reset">{post.node.title}</Link></span></td>
<td width="15%">[ {post.node.publishedAt} ]</td>
</tr>
</tbody>
</table>
          )
})}
</td>
      </tr>
            <tr>
        <td width="669" height="1" bgcolor="#e5e5e9"></td>
      </tr>
    </tbody>
    </table>     
      </td>
      {/* end 右栏 */}
    </tr>
    </tbody></table>
    </Layout>
  );
};

export default Category;
